













import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { isValid } from '@/helpers/values';

@Component
export default class Select extends Vue {
  @Prop() private items?: any[];
  @Prop() private value?: any;

  private data = this.value;

  private input(value: any) {
    this.$emit('input', value);
  }

  private change(value: any) {
    this.$emit('change', value);
  }
}
